export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";